import { useIncludes } from '@uswitch/ev-utils/context/selectors'
import { sortByDate } from '@uswitch/ev-utils/dates'

export const useCategoryGuides = ({ guides = [], pathname }) => {
  const includes = useIncludes()
  const filteredGuides = guides
    .filter(({ fields: { url } = {} }) => (pathname && url ? pathname !== url : true))
    .filter(guide => {
      if (guide?.fields?.variants?.length) return includes[guide.fields.variants[0].sys.id]
      else if (guide?.fields?.entry) return includes[guide.fields.entry.sys.id]
      else return includes[guide.fields.link?.sys.id]
    })
    .sort(sortByDate)

  return filteredGuides
}
